import React, { Component } from 'react'
import PropTypes from 'prop-types'

const color = PropTypes.color

export const theme = {
  backgroundColor: color
}

/**
 * Frame component
 */
export default class Frame extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    /**
     * Frame header name
     */
    name: PropTypes.string,

    styling: PropTypes.shape(theme)
  }

  static defaultProps = {
    name: 'Frame',
    styling: {
      backgroundColor: 'rgb(255, 255, 255)'
    }
  }

  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount () {
    const { name, children } = this.props
    if (children && children.props && name !== children.props.item.name) {
      children.props.item.update('name', name)
    }
  }

  static getDerivedStateFromProps (props, state) {
    const { name, children } = props
    if (children && children.props && name !== children.props.item.name) {
      children.props.item.update('name', name)
      return {}
    }
    return null
  }

  render () {
    const { styling: { backgroundColor } = {} } = this.props
    return (
      <div style={{ height: '100%', background: backgroundColor }}>
        {this.props.children}
      </div>
    )
  }
}
